<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="敏感词" prop="name">
                <el-input v-model="form.name" placeholder="请输入敏感词"></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="status">
                <el-switch v-model="form.status"></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { add, edit } from "@/api/product/word";
export default {
    data() {
        return {
            title: "新增敏感词",
            visible: false,
            form: {
                name: "",
                status: "1",
            },
            rules: {
                name: [{ required: true, message: "请输入敏感词" }],
            },
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.title = "编辑敏感词";
                this.form = {
                    name: row.name,
                    status: row.status == 1 ? true : false,
                    uuid: row.uuid,
                };
            } else {
                this.title = "新增敏感词";
                this.form = {
                    name: "",
                    status: true,
                };
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    status: this.form.status ? "1" : "2",
                };
                if (this.form.uuid) {
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
